module.exports = __webpack_public_path__ + "static/media/our-products-banner.9c6dbcf7.png";